module.exports = __webpack_public_path__ + "img/inboxaware-auth-background.0b0dbc45.webp";